import http from './_http'

// const notice = {
//   get: (id) => http.get(`api.user/board/notice/${id}`),
//   list: (m) => http.post(`api.user/board/notices/search`, m),
// }
// const faq = {
//   get: (id) => http.get(`api.user/board/faq/${id}`),
//   list: (m) => http.post(`api.user/board/faqs/search`, m),
// }
// const qna = {
//   get: (id) => http.get(`api.user/board/qna/${id}`),
//   list: (m) => http.post(`api.user/board/qnas/search`, m),
//   write: (m) => http.post(`api.user/board/qna`, m),
//   update: (id, m) => http.put(`api.user/board/qna/${id}`, m),
//   delete: (id) => http.delete(`api.user/board/qna/${id}`),
// }

const Board = (m) => { return http.post(`/board`, m); }
const Board_Call = (a, b, c) => Board({ target: a, cmd : b, body: c });
const Billing = (m) => { return http.post(`/billing`, m)}
const Billing_Call = (a, b, c) => Billing({ target: a, cmd : b, body: c });

export default { Board, Board_Call, Billing, Billing_Call }
export { Board, Board_Call, Billing, Billing_Call }


// const board  = {
//   notice, faq, qna
// }
// export default board
// export { notice, faq, qna }
